<template>
  <v-container>
    <v-row>
      <v-col>
        <p>
          Возвращает прогноз в указанной точке. В качестве параметров нужно указать координаты точки
          <b>{lat}</b>,
          <b>{lon}</b>.
          Результатом запроса является прогноз в заданной точке. Прогноз включает в себя все имеющиеся параметры и заблаговременности.
        </p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Authorization</td>
              <td>JWT токен доступа</td>
              <td>Bearer eyJhbGciOiJSUzI1NiIsImtp...</td>
            </tr>
            <tr>
              <td>Accept-Encoding</td>
              <td>
                Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
              </td>
              <td>gzip</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Запрос</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>По координатам и домену</td>
              <td>{lat} - широта; {lon} - долгота</td>
              <td>
                <code
                  style="word-break: break-all"
                >curl -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' '{{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/api/1.2/forecast/last/point?latitude=46.83483121393449&longitude=40.60272216796876'</code>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <div class="text-subtitle-1">Общие сведения</div>
          <p>Получить список активных территорий можно с помощью API.</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      response: {
        status_code: 200,
        result: {
          points: [
            {
              x: 33,
              y: 44
            }
          ],
          parameters: [
            {
              level_type: "surface",
              level: 0,
              pname: "2 metre dewpoint temperature",
              sname: "2d",
              unit: "c"
            },
            {
              level_type: "surface",
              level: 0,
              pname: "2 metre temperature",
              sname: "2t",
              unit: "c"
            }
          ],
          ref_time: "2021-12-25T00:00:00Z",
          predicts: [60, 120, 180, 240],
          values: [-0.5, -0.3, 0.1, 0.4, 3.6, 3.2, 2.9, 2.6]
        }
      }
    };
  }
};
</script>